import { MappedAEMProperties } from '../../../../types';
import { ContentBlock } from '../../../../lib/types/aemDataModels';
import Teaser from '../../base/Teaser/Teaser';
import Layout from '../../../common/Layout/Layout';
import styles from './TeaserList.module.scss';

export type TeaserListProps = {
  contentBlocks?: ContentBlock[];
} & MappedAEMProperties;

const TeaserList = ({ contentBlocks }: TeaserListProps) => {
  return (
    <Layout>
      <div className={styles.teaserGrid}>
        {contentBlocks?.map(block => (
          <Teaser key={block.uniqueId} {...block} />
        ))}
      </div>
    </Layout>
  );
};

export default TeaserList;
